import { render } from "./Edit.vue?vue&type=template&id=782fcdbc&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=ts"
export * from "./Edit.vue?vue&type=script&lang=ts"

import "./Edit.vue?vue&type=style&index=0&id=782fcdbc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-782fcdbc"

export default script